import {Route, Routes} from "react-router-dom";
import Login from "./pages/login";
import React from "react";
import Chat from "./pages/chat";
import {createTheme, Theme, ThemeProvider} from "@mui/material/styles";

let theme:Theme = createTheme({
    palette: {
        primary: {
            main: '#272A50',
            light: '#393C65',
            dark: '#1C1E3A',
        },
    },
    components:{
        MuiButton:{
            styleOverrides:{
                root:{
                    textTransform: 'unset',
                    boxShadow: 'unset'
                }
            }
        }
    }
})

export default function Liquid(){
    return (
        <ThemeProvider theme={theme}>
        <Routes>
            <Route path="/" element={<Chat />}/>
            <Route path="/login" element={<Login />}/>
        </Routes>
        </ThemeProvider>
    )
}